import styled from 'styled-components';
import { Typography, Button as MUIButton, Box } from '@mui/material';

export const Content = styled(Box)`
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(5.75, 3.9)};
  row-gap: ${({ theme }) => theme.spacing(3.5)};
  text-align: center;
  border-right: ${({ theme }) => `1px solid ${theme.palette.grey[300]}`};
`;

export const Title = styled(Typography)`
  &&& {
    font-size: 22px;
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  }

  color: ${({ theme }) => theme.palette.primary.light};
  text-transform: capitalize;
`;

export const TableTitle = styled(Typography)`
  &&& {
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    font-size: 16px;
    margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  }

  color: ${({ theme }) => theme.palette.primary.light};
  text-transform: capitalize;
`;

export const Description = styled(Typography)`
  &&& {
    font-size: 14px;
    line-height: 17px;
  }
`;

export const TableWrapper = styled(Box)`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Button = styled(MUIButton)`
  &:not(:disabled) {
    border-color: ${({ theme }) => theme.palette.primary.main} !important;
    color: ${({ theme }) => theme.palette.primary.main} !important;
  }
`;

Button.defaultProps = {
  variant: 'outlined',
};

export const ArticleImage = styled.img`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14),
    0px 1px 3px rgba(0, 0, 0, 0.12);
`;

export const Link = styled(MUIButton)`
  cursor: pointer;
  text-transform: uppercase;

  &&& {
    font-size: 13px !important;
  }
`;

Link.defaultProps = {
  variant: 'text',
  color: 'primary',
  size: 'small',
};
